<template>
    <div id="reExaminationAdjustment" class="base" v-if="!isloading">
        <div v-if="!showLoginflg">
        <div class="title-area">
            <div style="font-size: 24px; color: whitesmoke">Philips Care Portal</div>    
            <div style="font-size: 24px; color: whitesmoke"></div>
        </div>
        <div class="regist-area">
            <div v-if="isQueryError" id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">URLエラー</div>
                    <div style="color: whitesmoke">
                        指定されたページはURLが間違っているか、有効期限が切れています。
                    </div>
                </div>
            </div>
            <div v-else id="item-contens">
                <div style="maragin-bottom:20px;" v-if="!processComplete">
                    <div style="font-size: 20px; color: whitesmoke; margin-bottom:10px;">以下の{{title}}を実施しますか？</div>
                    <div class="card-content margin-top">
                        <div style="font-size: 20px; color: whitesmoke; margin-bottom:10px;">申込み概要(受付番号：{{receptionNo}})</div>
                        <hstRequestDetail v-if="requestType == `hst`" :data="showDetailTargetData" style="padding:20px;"/>
                        <kenshinRequestDetail v-if="requestType == `kenshin`" :data="showDetailTargetData" :isAccommodations="isAccommodations" style="padding:20px;"/>
                        <holterRequestDetail v-if="requestType == `holter`" :data="showDetailTargetData" :isHideAnalysisOptions="true" :class="{depositHolter: selectType=='reExamination' && showDetailTargetData.depositMachineFlag}" style="padding:20px;"/>
                        <div v-if="selectType=='reExamination' && requestType == `holter` && showDetailTargetData.depositMachineFlag" style="background-color: whitesmoke; padding:20px; padding-top:0px;">
                            <div class="printMargin printBreakInside" style="padding:10px; margin-bottom:5px; border: 1px solid; border-radius:5px;" >
                                <span style="font-size:20px;">院内貸出再検査情報</span>
                                <table>
                                    <tr>
                                        <th>シリアル番号<span class="require" /></th>
                                        <td>
                                            <select v-model="selectedSerial" validate="required" class="validate" name="シリアル番号">
                                                <option v-for="holterSerial in availableHolterSerialList" :value="holterSerial" :key="holterSerial">{{ holterSerial }}</option>
                                            </select>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div style="font-size: 20px; color: whitesmoke; margin-bottom:10px; margin-top:10px;">
                            <b-button v-if="selectType=='reExamination'" style="margin-left:5px; width:150px;" class="is-primary" @click="doReInspection()">再検査を実施する</b-button>
                            <b-button v-else style="margin-left:5px; width:150px;" class="is-primary" @click="doReInspection()">検査をキャンセル</b-button>
                            <b-button style="margin-left:5px; width:150px;" class="is-primary" @click="closeWindow()">画面を閉じる</b-button>
                            <br>
                            <span v-if="selectType=='reExamination' && requestType == `hst`" style="font-size: 16px;background-color:red;">※再検査を行う場合、患者様へ再検査のご連絡をしていただきますようお願い致します。</span>
                            <span v-if="selectType=='reExamination' && requestType == `kenshin`" style="font-size: 16px;background-color:red;">※再検査を行う場合、被験者様へ再検査のご連絡をしていただきますようお願い致します。</span>
                            <span v-if="selectType=='reExamination' && requestType == `holter` && !showDetailTargetData.depositMachineFlag" style="font-size: 16px;background-color:red;">※再検査を行う場合、患者様へ再検査のご連絡をしていただきますようお願い致します。</span>
                        </div>
                    </div>
                </div>
                <div class="card-content" v-else>
                    <div style="font-size: 20px; color: whitesmoke">{{title}}</div>
                    <div style="color: whitesmoke">{{title}} を受付けました。(受付番号：{{receptionNo}})</div>
                    <div v-if="selectType=='reExamination'">
                        <template v-if="requestType == `hst` || requestType == `holter`">
                            <span v-if="!showDetailTargetData.depositMachineFlag" style="color:whitesmoke;background-color:red;">※患者様へ再検査のご連絡をしていただきますようお願い致します。</span>
                        </template>
                        <template v-else>
                            <span style="color:whitesmoke;background-color:red;">※被験者様へ再検査のご連絡をしていただきますようお願い致します。</span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div v-else-if="showLoginflg">
            <login v-if="showLoginflg" @close-login="closeLogin"></login>
        </div>
    </div>
</template>

<script>
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
import login from '@/components/mock/login';

export default {
    name: "reExaminationAdjustment",
    data() {
        var query = this.$route.query.key;
        var showLoginflg = this.$route.hash ? true: false;
        return {
        query:query,
        isloading: true,
        isQueryError: true,
        title:"",
        receptionNo:"",
        showDetailTargetData: {},
        processComplete:false,
        requestType:"",
        selectType:"",
        isAccommodations:false,
        availableHolterSerialList:{},
        selectedSerial:"",
        showLoginflg:showLoginflg,
        };
    },
    methods: {
        closeWindow: function(){
            window.open('about:_blank', '_self').close()
        },
        closeLogin() {
            // ログイン成功で非表示にする
            this.showLoginflg = false
        },
        doReInspection: function(){
            this.isloading = true;
            // 再検査orキャンセル
            var shortestShippingDateList = this.getShortestShippingDate()
            try{
                if(this.requestType == `holter` && this.showDetailTargetData.depositMachineFlag) {
                    let elements = document.getElementsByClassName("validate")
                    let result = this.selfMadeValidation(elements)
                    if(result.isError){
                        this.showErrorMessage(result.msg)
                        this.isloading = false;
                        return;
                    }
                    this.$store.dispatch("requestReExaminationAdjustment", {
                        key: this.query,
                        shortestShippingDateList:shortestShippingDateList,
                        selectType:this.selectType,
                        serial: this.selectedSerial
                    }).then(result => {
                        if(result != null && result.status === 200 ) {
                            this.title = result.obj.title
                            this.receptionNo = result.obj.receptionNo
                            this.processComplete = true
                        }
                        this.isloading = false;
                    }).catch(error => {
                        this.isloading = false;
                    });
                } else {
                    this.$store.dispatch("requestReExaminationAdjustment", {
                        key: this.query,
                        shortestShippingDateList:shortestShippingDateList,
                        selectType:this.selectType
                    }).then(result => {
                        if(result != null && result.status === 200 ) {
                            this.title = result.obj.title
                            this.receptionNo = result.obj.receptionNo
                            this.processComplete = true
                        }
                        this.isloading = false;
                    }).catch(error => {
                        this.isloading = false;
                    });
                }
            }catch(err){
                this.isloading = false;
            }
            this.jumpToTop()
        },
    },
    computed: {},
    mounted: function(){
        var shortestShippingDateList = this.getShortestShippingDate()
        //keyの検証
        try {
            this.$store.dispatch("getChoiceMaster", {
            }).then(result => {
            }).catch(error => {
            });
            this.$store.dispatch("requestReExaminationAdjustment", {
                key: this.query,
                shortestShippingDateList:shortestShippingDateList,
                selectType:""
            }).then(result => {
                if(result != null && result.status === 200 ) {
                    this.title = result.obj.title
                    this.receptionNo = result.obj.receptionNo
                    this.selectType = result.obj.type
                    if(result.obj.hst){
                        this.requestType = "hst";
                        this.showDetailTargetData = result.obj.hst;
                    } else if(result.obj.kenshin){
                        this.requestType = "kenshin";
                        this.showDetailTargetData = result.obj.kenshin;
                        this.isAccommodations = this.showDetailTargetData.isAccommodations
                    } else if(result.obj.holter){
                        this.requestType = "holter";
                        this.showDetailTargetData = result.obj.holter;
                        if(result.obj.holter.depositMachineFlag){
                            this.availableHolterSerialList = result.obj.serialList;
                        }
                    }
                    this.isQueryError = false
                } else {
                    //パスワード入力画面は表示しないため、エラーメッセージ表示なし
                    this.showLoginflg = false;
                }
                this.isloading = false;
                //backgroundの変更
                document.documentElement.style.background = "rgb(0, 114, 218)";
            }).catch(error => {
                this.isloading = false;
            });
        } catch(err){
            this.isloading = false;
        }
    },
    components: {
        hstRequestDetail:HSTRequestDetail,
        kenshinRequestDetail:KenshinRequestDetail,
        holterRequestDetail:HolterRequestDetail,
        login: login,
    },
};
</script>
<style lang="scss" scoped>
.base {
    min-height: 1000px;
    background: linear-gradient(
        45deg,
        rgba(0, 0, 139, 0.7) 0%,
        rgba(0, 52, 120, 0.7) 100%
    );
    background: -moz-linear-gradient(
        45deg,
        rgba(0, 0, 139, 0.7) 0%,
        rgba(0, 52, 120, 0.7) 100%
    );
    background: -webkit-linear-gradient(
        45deg,
        rgba(0, 0, 139, 0.7) 0%,
        rgba(0, 52, 120, 0.7) 100%
    );
}
.title-area{
    padding-top:50px;
    margin-bottom:25px;
}
.regist-area{
    width: 700px;
}
.auth-area {
    width: 300px !important;
}
.regist-area,
.auth-area {
    margin : 0 auto;
}
.card-content {
    border-color: whitesmoke !important;
    margin-bottom:5px;
}
.summaryArea
{
    min-height: 450px;
}

.regist-area > input,
.auth-area > input{
    margin-bottom:10px;
}
.opbutton {
    margin-top:10px;
    width: 100px;
}
.depositHolter {
    padding-bottom: 10px !important; 
}
#HSTRequestDetail,
#KenshinRequestDetail,
#HolterRequestDetail {
    background-color: whitesmoke;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/guest/requestUrl/reExaminationAdjustment.vue